import { render, staticRenderFns } from "./FaradayCageViz.vue?vue&type=template&id=04b994a1&scoped=true"
import script from "./FaradayCageViz.vue?vue&type=script&lang=js"
export * from "./FaradayCageViz.vue?vue&type=script&lang=js"
import style0 from "./FaradayCageViz.vue?vue&type=style&index=0&id=04b994a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b994a1",
  null
  
)

export default component.exports